export default {"src":"/_next/static/media/HL.bd0b9bb8.svg","height":18,"width":18};